function t(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
export {
  t as capitalizeFirstLetter
};
